import * as React from "react";
import { RecommendationCell } from "./StatusIcon";

interface Props {
  dateCompleted: any;
  testId: number | undefined;
  recommendation: OnroadRecommendationType | undefined;
}

export const DoreRecommendationCell: React.FC<Props> = ({
  dateCompleted,
  testId,
  recommendation,
}) => (
  <RecommendationCell status={recommendation} dateCompleted={dateCompleted} testId={testId} />
);
